import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-historico-consultas',
  templateUrl: './consulta-historico-consultas.component.html',
  styleUrls: ['./consulta-historico-consultas.component.scss']
})
export class ConsultaHistoricoConsultasComponent implements OnInit {
  // title = "CONSULTAS REALIZADAS";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
